<template>
  <modal-dialog
    @click="close"
    :show="show"
    :title="title"
    :instructions="instructions"
    :dialogInputs="dialogInputs"
    @onClose="close"
    @onSubmit="submit()"
  >
    <div v-if="createAccount">
      <div>Already have an account?</div>
      <md-button @click="createAccount=false">Log in instead</md-button>
    </div>
    <div v-else>
      <div>Don't have an account?</div>
      <md-button @click="createAccount=true">Create one for free!</md-button>
    </div>
  </modal-dialog>
</template>

<script>
import gql from "graphql-tag";
import { DialogInputTypes } from "@/js/helper";
import BaseDialog from "./baseDialog.vue";

export default {
  name: "LoginDialog",
  extends: BaseDialog,
  data: function() {
    return {
      createAccount: false,
      name: {
        label: "Your name",
        required: true
      },
      email: {
        label: "Email",
        type: DialogInputTypes.email,
        required: true
      },
      pw: {
        label: "Password",
        type: DialogInputTypes.pw,
        required: true
      },
      confirmPw: {
        label: "Confirm Password",
        type: DialogInputTypes.pw,
        required: true
      }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return this.createAccount
          ? [this.name, this.email, this.pw, this.confirmPw]
          : [this.email, this.pw];
      }
    },
    title: {
      get() {
        return `Quick Tourney - ${
          this.createAccount ? "Create account" : "Sign in"
        }`;
      }
    },
    instructions: {
      get() {
        return `${
          this.createAccount ? "Create an" : "Log into your"
        } account in order to manage your tournaments`;
      }
    }
  },
  methods: {
    submit(results) {
      if (this.createAccount) {
        if (this.pw.value === this.confirmPw.value)
          return this.$apollo
            .mutate({
              mutation: gql`
                mutation($name: String!, $authInput: AuthInput!) {
                  createUser(name: $name, authInput: $authInput) {
                    id
                  }
                }
              `,
              variables: {
                name: this.name.value,
                authInput: {
                  emailLogin: {
                    email: this.email.value,
                    password: this.pw.value
                  }
                }
              }
            })
            .then(result => {
              this.$store.commit(
                "setNotification",
                `Account created, please log-in to manage your tournaments`
              );
            })
            .catch(err => {
              window.alert("Failed to create account");
            });
        else window.alert("Passwords do not match");
      } else
        return this.$apollo
          .mutate({
            mutation: gql`
              mutation($emailLogin: EmailLogin!) {
                signinUser(emailLogin: $emailLogin) {
                  token
                  user {
                    id
                    name
                    email
                    maxTournaments
                  }
                }
              }
            `,
            variables: {
              emailLogin: { email: this.email.value, password: this.pw.value }
            }
          })
          .then(result => {
            const cu = result.data.signinUser;
            this.$store.commit("setCurrentUser", cu);
            this.$router.push({ path: "/myTournaments" });
            this.$store.commit("setNotification", `Welcome ${cu.user.name}`);
          })
          .catch(err => {
            window.alert("Login failed");
          });
    }
  }
};
</script>


// WEBPACK FOOTER //
// loginDialog.vue?0bf05970